import { Type } from "@sinclair/typebox";
export function NullableSchema(schema) {
    return Type.Unsafe(Object.assign(Object.assign({}, schema), { nullable: true }));
}
export const Nullable = (schema) => Type.Union([schema, Type.Null()]);
//In order to use origo tabs where its panels are not its direct sibling we have to set the 'for' attribute on buttons. Typescript does not like that, and it´s difficult to @ts-ignore in template.
const escapeTypeCheck = (x) => x;
export function tabFor(tabId) {
    return escapeTypeCheck({ for: tabId });
}
//# sourceMappingURL=type-util.js.map